const form2 = {
  formId2: "new-user-form-2",
  formField2: {
    taxAlternatePayerName: {
      name: "taxAlternatePayerName",
      label: "Bên Việt Nam khấu trừ và nộp thuế thay:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập Bên Việt Nam khấu trừ và nộp thuế thay",
    },
    taxAlternatePayerId: {
      name: "taxAlternatePayerId",
      label: "Mã số thuế nộp thay của Bên Việt Nam:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế nộp thay của Bên Việt Nam",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
  },
};

export default form2;
